import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC017_Request,
  IAPI_FAC017_Response,
  IAPI_FAC021_Request,
  IAPI_FAC021_Response,
} from "../../../type/apiType";

// 部分解除施設一覧参照
const httpAPI_FAC021 = async (
  param: IAPI_FAC021_Request
): Promise<IAPI_FAC021_Response> => {
  const res = await http.post(ApiUrl.API_FAC021, { ...param });

  return res.data;
};

// 退職手当共済契約部分解除一括更新
const httpAPI_FAC017 = async (
  param: IAPI_FAC017_Request
): Promise<IAPI_FAC017_Response> => {
  const res = await http.post(ApiUrl.API_FAC017, { ...param });
  return res.data;
};

export { httpAPI_FAC021, httpAPI_FAC017 };
